export const INPUT_OPTION_NONE = 'INPUT_OPTION_NONE'
export const INPUT_OPTION_MIC = 'INPUT_OPTION_MIC'
export const INPUT_OPTION_LINE = 'INPUT_OPTION_LINE'
export const INPUT_OPTION_GUITAR = 'INPUT_OPTION_GUITAR'
export const INPUT_OPTION_USB = 'INPUT_OPTION_USB'